import { render, staticRenderFns } from "./SoftFairLeistungen.vue?vue&type=template&id=12855540&"
import script from "./SoftFairLeistungen.vue?vue&type=script&lang=js&"
export * from "./SoftFairLeistungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports